import React, { useState, useRef } from 'react';
import { Col, Row, Form, Button } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import { useLocation } from 'react-router-dom';

const FormSec = ({ columnWidth }) => {
  const location = useLocation();
  const isContactPage = location.pathname === '/contact'; 
  const formControlStyle = {
      color: isContactPage ? 'black' : 'white'
  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const formRef = useRef();

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_g8b4k35',      // Replace with your EmailJS service ID
      'template_3q07hjo',     // Replace with your EmailJS template ID
      formRef.current,
      'ew4fEdHohn1dk7uDs'       // Replace with your EmailJS public key
    )
    .then(
      (result) => {
        alert('Message sent successfully!');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      },
      (error) => {
        alert('Failed to send message. Please try again.');
        console.error(error.text);
      }
    );
  };

  return (
    <>
      <h2 className="text-center mb-4">Get in Touch</h2>
      <Row className="justify-content-center">
        <Col md={10}>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Row>
                <Col md={columnWidth}>
                  <Form.Control
                    type="text"
                    placeholder="Your Name"
                    name="name"
                    value={formData.name}
                    required
                    onChange={handleChange}
                    style={formControlStyle}
                  />
                </Col>
                <Col md={columnWidth}>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={formData.email}
                    required
                    onChange={handleChange}
                    style={formControlStyle}
                  />
                </Col>
                <Col md={columnWidth}>
                  <Form.Control
                    type="tel"
                    placeholder="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    style={formControlStyle}
                  />
                </Col>
                <Col md={columnWidth}>
                  <Form.Control
                    type="text"
                    placeholder="Subject"
                    name="subject"
                    value={formData.subject}
                    required
                    onChange={handleChange}
                    style={formControlStyle}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Message"
                name="message"
                required
                value={formData.message}
                onChange={handleChange}
                style={formControlStyle}
              />
            </Form.Group>

            <Button variant="danger gallery-btn" type="submit" className="w-100 mt-4">
              Send Your Message
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default FormSec;
